// Shape of proj_saco_CookieConsentConfig.ConfigJson, with defaults for anything missing.
export interface ConsentStyle {
  background: string;
  text: string;
  link: string;
  toggleOn: string;
  buttonBackground: string;
  buttonText: string;
  buttonRadius: number;
}

export interface ConsentConfig {
  version: number;
  layout: 'banner' | 'modal';
  iconPosition: 'left' | 'right';
  privacyUrl: Record<string, string>;
  texts: Record<string, Record<string, string>>;
  style: ConsentStyle;
}

export const DEFAULT_STYLE: ConsentStyle = {
  background: '#ffffff',
  text: '#1f1f1f',
  link: '#00838f',
  toggleOn: '#1f1f1f',
  buttonBackground: '#00838f',
  buttonText: '#ffffff',
  buttonRadius: 4,
};

const isObject = (v: unknown): v is Record<string, any> => !!v && typeof v === 'object' && !Array.isArray(v);

export const parseConfig = (json: string | null | undefined): ConsentConfig => {
  let raw: Record<string, any> = {};
  try {
    const parsed = json ? JSON.parse(json) : {};
    raw = isObject(parsed) ? parsed : {};
  } catch (e) {
    raw = {};
  }
  const style = isObject(raw.style) ? raw.style : {};
  return {
    version: Number.isInteger(raw.version) && raw.version > 0 ? raw.version : 1,
    layout: raw.layout === 'modal' ? 'modal' : 'banner',
    iconPosition: raw.iconPosition === 'right' ? 'right' : 'left',
    privacyUrl: isObject(raw.privacyUrl) ? raw.privacyUrl : {},
    texts: isObject(raw.texts) ? raw.texts : {},
    style: {
      background: style.background || DEFAULT_STYLE.background,
      text: style.text || DEFAULT_STYLE.text,
      link: style.link || DEFAULT_STYLE.link,
      toggleOn: style.toggleOn || DEFAULT_STYLE.toggleOn,
      buttonBackground: style.buttonBackground || DEFAULT_STYLE.buttonBackground,
      buttonText: style.buttonText || DEFAULT_STYLE.buttonText,
      buttonRadius: Number.isFinite(Number(style.buttonRadius)) ? Number(style.buttonRadius) : DEFAULT_STYLE.buttonRadius,
    },
  };
};

/** Puts the style on :root as CSS variables so the dialog, icon and all placeholders (also inside rich text) pick it up. */
export const applyStyleVars = (s: ConsentStyle) => {
  const root = document.documentElement.style;
  root.setProperty('--cc-bg', s.background);
  root.setProperty('--cc-text', s.text);
  root.setProperty('--cc-link', s.link);
  root.setProperty('--cc-toggle-on', s.toggleOn);
  root.setProperty('--cc-btn-bg', s.buttonBackground);
  root.setProperty('--cc-btn-text', s.buttonText);
  root.setProperty('--cc-btn-radius', `${s.buttonRadius}px`);
};
